import React, { JSX } from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { SortField, SortOrder } from './jobsViewUtils';

export function JobsViewToolbar(props: {
  total: number;
  searchQuery: string;
  sortField: SortField;
  sortOrder: SortOrder;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSortSelect: (field: SortField, order: SortOrder) => void;
}): JSX.Element {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" component="h2">
            Jobs ({props.total})
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search jobs..."
              value={props.searchQuery}
              onChange={props.onSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Sort</InputLabel>
              <Select
                value={`${props.sortField}-${props.sortOrder}`}
                label="Sort"
                onChange={e => {
                  const [field, order] = e.target.value.split('-') as [SortField, SortOrder];
                  props.onSortSelect(field, order);
                }}
              >
                <MenuItem value="updatedAt-desc">Updated ↓</MenuItem>
                <MenuItem value="updatedAt-asc">Updated ↑</MenuItem>
                <MenuItem value="createdAt-desc">Created ↓</MenuItem>
                <MenuItem value="createdAt-asc">Created ↑</MenuItem>
                <MenuItem value="company-asc">Company A-Z</MenuItem>
                <MenuItem value="company-desc">Company Z-A</MenuItem>
                <MenuItem value="title-asc">Title A-Z</MenuItem>
                <MenuItem value="title-desc">Title Z-A</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
